import React, { useState, useEffect } from "react"
import '../../css/Components/InputSearch/InputSearch.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { baseURL, sistemaURL } from '../url.js';
Modal.setAppElement('#root');
export default function InputSearch() {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleSearch = async (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);
        if (searchTerm.length < 3) { return }
        fetch(`${sistemaURL}/web/getArticulosPorNombre?nombre=` + searchTerm, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                //setOptions(response);
                setFilteredResults(data);
                //setIsLoading(false);
                setShowResults(data.length > 0);
                setNoResults(data.length === 0);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
        //setFilteredResults(filteredResults);
    };

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (
        <div className="fondo-input">
            <div className="search-container">
                <div className="inputSerch" onClick={openModal}>
                    <FontAwesomeIcon icon={faSearch} className="search-icon" onClick={openModal} />
                    <strong>Buscar</strong>
                </div>
                <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="modalInput" overlayClassName="overlayInput">
                    <fieldset className="inputSearch">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="input"
                        />
                    </fieldset>
                    {showResults && (
                        <div className="modalSearch">
                            {/* {filteredResults.map(({ categoria, productos }) => (
                                <div key={categoria.idCategoria} className="sectionSearch">
                                    <h3>{categoria.categoria}</h3>
                                    <hr />
                                    {productos.map((producto) => (
                                        <div key={producto.idProducto}>
                                            <Link to={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={producto.imagen1} alt="" />
                                                <p>{producto.titulo}</p>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            ))} */}
                            {filteredResults.map((item, key) => (
                                <div key={key} className="sectionSearch">
                                    <Link to={`/producto/${item.id}/${item?.label?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                        {item.imagen != "" && <img src={sistemaURL + "assets/images/imagenesArticulos/" + item.imagen} alt="" />}
                                        <p>{item.label}</p>
                                    </Link>
                                </div>
                            ))}
                            {noResults && <p>No se encontraron resultados.</p>}
                        </div>
                    )}
                </Modal>
            </div>
        </div>
    );
}
